<template>
  <div
    class="max"
    :style="
      scrollTop > 700 ? 'box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);' : ''
    "
  >
    <div class="header container">
      <!-- logo -->
      <div class="logo">
        <img
          :src="language == 'cn' ? gImg.index.logo : gImg.index.logoEN"
          @click="index()"
        />
      </div>
      <!-- 导航 -->
      <div>
        <!-- 大屏导航 -->
        <ul class="header-ul">
          <li
            class="header-li"
            :class="language !== 'cn' ? 'es font-12' : 'font-15'"
            v-for="(item, index) in list"
            :key="index"
            @click="changExternal(item)"
          >
            <router-link :to="{ path: '/' + item.external }" class="link">
              {{ $t(item.title) }}</router-link
            >
          </li>
          <!-- <li class="lineRight"></li> -->
          <li class="header-li font-13 language">
            <!-- @click="changeIanguage('cn')" -->
            <span :class="language == 'cn' ? 'isColor' : ''">中文</span>
            &nbsp;/ &nbsp;
            <!-- @click="changeIanguage('en')" -->
            <span :class="language == 'en' ? 'isColor' : ''">English</span>
          </li>
        </ul>
        <!-- 小屏导航 -->
        <div class="md-none small-menu" style="" @click="changeMenu">
          <svg
            viewBox="80 80 896 896"
            focusable="false"
            class=""
            data-icon="menu"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
            style="color:#2e3a61;"
          >
            <path
              d="M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"
            ></path>
          </svg>
        </div>
        <Modal
          title=""
          v-model="isMenu"
          :footer-hide="true"
          class-name="vertical-center-modal ulcheck"
        >
          <li
            class="header-small-li font-16"
            v-for="(item, index) in list"
            :key="index"
            @click="changExternal"
          >
            <router-link :to="{ path: '/' + item.external }">{{
              $t(item.title)
            }}</router-link>
          </li>
          <li class="header-small-li font-16">
            <span
              :class="language == 'cn' ? 'isColor' : ''"
              @click="changeIanguage('cn')"
              >中文</span
            >
            /
            <span
              :class="language == 'en' ? 'isColor' : ''"
              @click="changeIanguage('en')"
              >English</span
            >
          </li>
        </Modal>
      </div>
    </div>
    <div style="width: 1290px; margin: 0 auto">
      <div class="header-center">
        <img
          :src="language == 'cn' ? gImg.index.logo : gImg.index.logoEN"
          @click="index()"
        />
      </div>
    </div>
    <div class="container space-between">
      <div
        class="follow font-16 flex"
        :class="language !== 'cn' && 'ArialNarrow'"
      >
        <div
          :class="['followText']"
          @click="changHot(11111)"
        >
          <span :class="{'active':current == '11111'}">{{ $t(hot) }}</span>
          <span :style="letters" >/</span>
        </div>
        <div
          :class="['followText']"
          v-for="(item, index) in hotList"
          :key="index"
          @click="changTab(index)"
          :id="index"
        >
          <span :style="letter" :class="[current == index ? 'active' : '']">{{
            item.name
          }}</span>
          <span :style="letters" v-if="index < hotList.length - 1">/</span>
        </div>
      </div>
      <div class="search">
        <el-input
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          v-model="inputSearch"
          @keyup.enter.native="searchEntInfo"
          clearable
        >
        </el-input>
      </div>
      <!-- <img :src="gImg.index.searchBox" class="searchBox" /> -->
    </div>

      <div class="header-bg" style="width:100%; line-height:1;display:gaid;"><img :src="gImg.index.bg" alt=""></div>
  </div>
</template>
<script>
import VueI18n from "vue-i18n";
import { newCategory } from "../../api/newCategory.js";
export default {
  name: "",
  // 定义属性
  data() {
    return {
      inputSearch: "",
      letter: "",
      letters: "",
      isPhoneSize: document.body.clientWidth,
      isPhone: document.body.clientWidth > 1150 ? true : false,
      scrollTop: 0,
      isScrollTop: true,
      screenWidth: 0,
      isMenu: false,
      language:
        window.localStorage.getItem("language") == null
          ? "cn"
          : window.localStorage.getItem("language"),
      external: "index",
      list: [
        // {
        //   title: "header.Trending",
        //   external: "affairs",
        // },

        {
          title: "header.dynamics",
          external: "dynamics",
        },
        {
          title: "header.research",
          external: "research",
        },
        {
          title: "header.journal",
          external: "journal",
        },
        {
          title: "header.countryStats",
          external: "countryStats",
        },
        {
          title: "header.naHsien",
          external: "naHsien",
        },
        {
          title: "header.support",
          external: "support",
        },
        {
          title: "header.center",
          external: "bylaws",
        },
        // {
        //   title: "header.contact",
        //   external: "contact",
        // },
      ],
      hot: "hot",
      hotList: [],
      current: "index",
    };
  },
  // 监控data中的数据变化
  watch: {
    screenWidth(res) {
      if (res > 1400) {
        this.isMenu = false;
      }
      if (res > 1150) {
        this.isPhone = true;
      } else {
        this.isPhone = false;
      }
    },
    scrollTop(newVal, oldVal) {
      if (newVal < oldVal) {
        this.isScrollTop = true;
      } else {
        this.isScrollTop = false;
      }
    },
  },
  created() {
    newCategory({
      language: localStorage.getItem("language"),
    }).then((res) => {
      this.hotList = res.data.data;
    });
    if (localStorage.getItem("language") == "cn") {
      this.letter = "margin-left: 5px;";
      this.letters = "padding:7px;margin-left: 4px;";
    } else {
      this.letter = "letter-spacing:-1px";
      this.letter = "padding:7px;";
    }
  },
  // 方法集合
  methods: {
    //实时追踪跳转
    changHot(id) {
      this.current = id;
      this.$router.push({path:'/affairs'});
    },
    //搜索跳转
    searchEntInfo() {
      this.inputSearch == ""
        ? this.$message({
            message: "文字不能为空",
            type: "warning",
          })
        : this.$router.push({
            path: "/search/aindex",
            query: { searchText: this.inputSearch },
          });
    },
    index() {
      this.$router.push("/index");
    },
    changTab(id) {
      this.current = id;
      id = "a" + id;
      this.$router.push("/hotspot/" + id);
      document.getElementById(id).scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
        alignTo: false,
      });
    },
    // 改变预言
    changeIanguage(language) {
      this.language = language;
      console.log(this.language);
      window.localStorage.setItem("language", language);
      this.$i18n.locale = language;
      this.$emit("changeLanguage", language);
      let staorage = window.localStorage;
      if (language == "cn") {
        staorage["language"] = "cn";
        this.$router.go(0);
      }
      if (language == "en") {
        staorage["language"] = "en";
        this.$router.go(0);
      }
    },
    changExternal(item) {
      if (item.external === "countryStats") {
        console.log(123);
        window.open("http://www.acnworldwide.com/country");
        return;
      }
      console.log(external, "external");
      this.isMenu = false;
    },
    changeMenu() {
      this.isMenu = !this.isMenu;
    },
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.screenWidth = document.body.clientWidth;
        this.isPhoneSize = document.body.clientWidth;
        that.$emit("clientWidth", document.body.clientWidth);
      })();
    };
    window.onscroll = (res) => {
      this.scrollTop = document.documentElement.scrollTop;
      this.isMenu = false;
    };
  },
};
</script>
<style scoped src="@/css/header.css" />



// WEBPACK FOOTER //
// src/components/header.vue